"use client";

import { c as _c } from "react/compiler-runtime";
import { PriceChart } from "@/components/PriceChart";
import { api } from "@/lib/trpc/client";
interface TokenChartSectionProps {
  slug: string;
  symbol: string;
  tokenName: string;
  initialPrice?: number | null;
  circulatingSupply?: number | null;
  marketCap?: number | null;
}
export function TokenChartSection(t0) {
  const $ = _c(15);
  const {
    slug,
    symbol,
    tokenName,
    initialPrice,
    circulatingSupply,
    marketCap
  } = t0;
  let t1;
  if ($[0] !== slug) {
    t1 = {
      slug,
      days: "30"
    };
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      staleTime: 300000
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: priceHistory
  } = api.token.getPriceHistory.useQuery(t1, t2);
  let t3;
  if ($[3] !== priceHistory) {
    t3 = priceHistory?.map(_temp) ?? [];
    $[3] = priceHistory;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const historicalPrices = t3;
  let t4;
  if ($[5] !== priceHistory) {
    t4 = priceHistory?.filter(_temp2).map(_temp3) ?? [];
    $[5] = priceHistory;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const marketCapHistory = t4;
  let t5;
  if ($[7] !== circulatingSupply || $[8] !== historicalPrices || $[9] !== initialPrice || $[10] !== marketCap || $[11] !== marketCapHistory || $[12] !== symbol || $[13] !== tokenName) {
    t5 = <PriceChart symbol={symbol} tokenName={tokenName} initialPrice={initialPrice} historicalPrices={historicalPrices} marketCapHistory={marketCapHistory} circulatingSupply={circulatingSupply} currentMarketCap={marketCap} />;
    $[7] = circulatingSupply;
    $[8] = historicalPrices;
    $[9] = initialPrice;
    $[10] = marketCap;
    $[11] = marketCapHistory;
    $[12] = symbol;
    $[13] = tokenName;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp3(p_1) {
  return {
    timestamp: new Date(p_1.timestamp).getTime(),
    marketCap: p_1.marketCap
  };
}
function _temp2(p_0) {
  return p_0.marketCap != null && p_0.marketCap > 0;
}
function _temp(p) {
  return {
    timestamp: new Date(p.timestamp).getTime(),
    price: p.price
  };
}